/**
 * Utility helper functions
 */

/**
 * Smooth scroll to element by ID
 * @param {string} elementId - ID of the element to scroll to
 * @param {number} offset - Offset from top (for fixed header)
 */
export const scrollToElement = (elementId, offset = 80) => {
    const element = document.getElementById(elementId);
    if (element) {
        const top = element.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({
            top,
            behavior: 'smooth'
        });
    }
};

/**
 * Format phone number for display
 * @param {string} phone - Raw phone number
 * @returns {string} Formatted phone number
 */
export const formatPhone = (phone) => {
    // Remove all non-digit characters
    const digits = phone.replace(/\D/g, '');

    // Format as +998 XX XXX XX XX
    if (digits.length === 12 && digits.startsWith('998')) {
        return `+${digits.slice(0, 3)} ${digits.slice(3, 5)} ${digits.slice(5, 8)} ${digits.slice(8, 10)} ${digits.slice(10)}`;
    }

    return phone;
};

/**
 * Validate phone number (Uzbekistan format)
 * @param {string} phone - Phone number to validate
 * @returns {boolean} Whether phone is valid
 */
export const validatePhone = (phone) => {
    const digits = phone.replace(/\D/g, '');
    // Uzbekistan phone: +998 XX XXX XX XX (12 digits)
    return digits.length >= 9 && digits.length <= 12;
};

/**
 * Debounce function
 * @param {Function} func - Function to debounce
 * @param {number} wait - Wait time in ms
 * @returns {Function} Debounced function
 */
export const debounce = (func, wait) => {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
};

/**
 * Check if element is in viewport
 * @param {HTMLElement} element - Element to check
 * @returns {boolean} Whether element is visible
 */
export const isInViewport = (element) => {
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
};

/**
 * Get current language name
 * @param {string} lang - Language code
 * @returns {string} Language name
 */
export const getLanguageName = (lang) => {
    const names = {
        uz: "O'zbekcha",
        ru: 'Русский',
        en: 'English'
    };
    return names[lang] || lang;
};

/**
 * Get short language code for display
 * @param {string} lang - Language code
 * @returns {string} Short code
 */
export const getLanguageCode = (lang) => {
    const codes = {
        uz: 'UZ',
        ru: 'RU',
        en: 'EN'
    };
    return codes[lang] || lang.toUpperCase();
};
